import {
  Waves, Feather, CloudRain, Heart, Sprout, Compass, Briefcase, Sun,
} from "lucide-react";
import { WHO_I_HELP } from "../../data/content";
import { Reveal } from "../../lib/motion";

const ICONS = { Waves, Feather, CloudRain, Heart, Sprout, Compass, Briefcase, Sun };

export const WhoIHelp = () => {
  return (
    <section className="py-24 lg:py-36 bg-cream" aria-labelledby="who-heading">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-16 lg:mb-20">
          <Reveal><p className="overline text-sage-dark mb-5">Who I help</p></Reveal>
          <Reveal delay={0.05}>
            <h2 id="who-heading" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05] tracking-tight">
              Whatever you're carrying, you're welcome here.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-ink-soft leading-relaxed">
              You don't need the right words or a clear reason to reach out. If something
              feels heavy, that's reason enough. These are some of the things I help with —
              and whatever brings you, we'll take it gently, together.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {WHO_I_HELP.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.title} delay={(i % 4) * 0.08}>
                <article
                  data-testid="who-card"
                  className="group h-full rounded-3xl bg-white border border-sage-light/40 p-7 lg:p-8 shadow-soft hover:shadow-float hover:-translate-y-1 transition-all duration-500"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-cream-100 text-sage-dark group-hover:bg-sage-dark group-hover:text-cream transition-colors duration-500">
                    <Icon size={22} strokeWidth={1.5} />
                  </span>
                  <h3 className="mt-6 font-serif text-2xl text-ink">{item.title}</h3>
                  <p className="mt-3 text-[0.95rem] text-ink-soft leading-relaxed">{item.text}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
